import { createSlice } from "@reduxjs/toolkit";
import Cookies from "js-cookie";
const cookie = Cookies.get("user") || null;
let userData = "";
if (cookie) {
  userData = JSON.parse(cookie);
}
export const newenquirySlice = createSlice({
  name: "newenquiryReducer",
  initialState: {
    currentPage: 1,
    filters: {
      startdate: "",
      enddate: "",
      number: "",
      callType: "",
      attended: "",
      leadowner:
        userData?.Role === process.env.REACT_APP_ROLE_ADMIN_S ||
        userData?.Role === process.env.REACT_APP_ROLE_HR
          ? ""
          : userData?.Name || "",
    },
  },
  reducers: {
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setReduxFilters: (state, action) => {
      state.filters = action.payload;
    },
  },
});

export const { setCurrentPage, setReduxFilters } = newenquirySlice.actions;
export default newenquirySlice.reducer;
